export function fontStyle_apply(font_type){
    // 폰트 타입을 페이지 요소에 적용
    const elements = document.querySelectorAll('.WeddingBodyText, .WeddingTitleText, .year-month, .sec_cal, .side_contents, .BtnIcon');
    elements.forEach(element => {
      element.style.fontFamily = font_type;
    });
}
